module.exports = __webpack_public_path__ + "img/green-money-icon.8648a458.svg";